import { Injectable } from '@angular/core';
import { DataService }       from '@omnilib/services/data.service';
import { ListService }       from '@omnilib/services/list.service';
import { RouterService }     from '@omnipas/services/router.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleDataService {
  constructor( public data:           DataService
             , public list:           ListService
             , public router:         RouterService
             ) {
  }

  countrycode:        string = 'NL';
  licenseplate:       string = '';
  chargingcardnumber: string = '';

  found:              boolean = false;

  async get() {
    if ( this.router.freefields['personfreefields'] != undefined ) {
      this.found              = true;
      this.countrycode        = this.list.getValue( this.router.freefields['personfreefields'], 'freeField01', true );
      this.licenseplate       = this.list.getValue( this.router.freefields['personfreefields'], 'freeField02', true );
      this.chargingcardnumber = this.list.getValue( this.router.freefields['personfreefields'], 'freeField03', true );
    }
  }

  async update() {
    let params = { "freeField01" : this.countrycode
                 , "freeField02" : this.licenseplate
                 , "freeField03" : this.chargingcardnumber
                 }


    let result = await this.data.callapi ( this.found ?  'put' : 'post', 'freefield/person', params );

    if ( result['result']['code'] && result['result']['code'] == '0' ) {
      return true;
    } else {
      return false;
    }
  }
}
